import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {

  public selectIndex = 0;
  public navList = ['리스트', '그리다', '그리톡', '설명서'];

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  public goPage(index: any) {
    this.selectIndex = index;
    switch (this.selectIndex) {
      case 0: {
        this.router.navigate(['list']);
        break;
      }
      case 1: {
        this.router.navigate(['create']);
        break;
      }
      case 2: {
        this.router.navigate(['chatbot']);
        break;
      }
      case 3: {
        this.router.navigate(['desc']);
        break;
      }
    }
  }

  public goList() {
    this.selectIndex = 0;
    this.router.navigate(['list']);
  }

  public goCreate() {
    this.selectIndex = 1;
    this.router.navigate(['create']);
  }

  public goChatbot() {
    this.selectIndex = 2;
    this.router.navigate(['chatbot']);
  }

  public goDesc() {
    this.selectIndex = 3;
    this.router.navigate(['desc']);
  }

}
